<script lang="ts">
  import { onMount } from 'svelte';
  import { estServeur } from '$plateforme/environnement';
  import { réécritFragmentDepuis } from '../navigation/fragmentDeNavigation.svelte';
  import NavigationTertiaire from '../navigation/NavigationTertiaire.svelte';
  import { type PropriétésFilAriane } from '../ui/filAriane';
  import HerosRiche from '../ui/HerosRiche.svelte';
  import Lien from '../ui/Lien.svelte';
  import MotEnExergue from '../ui/MotEnExergue.svelte';
  import Notice from '../ui/Notice.svelte';
  import DocumentationNis2 from './DocumentationNis2.svelte';
  import ExigencesNis2 from './ExigencesNis2.svelte';
  import Presentation from './Presentation.svelte';
  import Solutions from './Solutions.svelte';

  const { itemsCyber, featureFlagNis2CyFun23 = false, exigences = undefined, guides = undefined } = $props();

  const liens = [
    { label: 'Présentation NIS 2', fragment: '#presentation' },
    { label: 'Exigences et comparaison', fragment: '#exigences' },
    { label: 'Solutions pour vous accompagner', fragment: '#solutions' },
    { label: 'Documentation et FAQ', fragment: '#documentation' },
  ];
  let lienActif = $state('#presentation');
  const propriétésFilAriane: PropriétésFilAriane = { feuille: 'Directive NIS 2', fondSombre: true };

  onMount(() => {
    const fragments = liens.map((lien) => lien.fragment);
    réécritFragmentDepuis(fragments, '&');
  });
</script>

<HerosRiche
  description="Préparez-vous et renforcez dès à présent le niveau de cybersécurité de votre organisation."
  propriétésFilAriane={{ ...propriétésFilAriane, fondSombre: false }}
  variante="bleu-clair"
>
  {#snippet titreHtml()}
    Directive <MotEnExergue motif="cercle">NIS 2</MotEnExergue>
  {/snippet}
  {#snippet illustration()}
    <img src="/assets/images/nis2-noir.svg" alt="NIS2" />
  {/snippet}
  {#snippet actions()}
    <Lien
      apparence="bouton"
      blank
      etire
      href="https://club.ssi.gouv.fr/#/nis2/introduction"
      icone="external-link-line"
      iconeADroite
      libelle="Pré-enregistrer mon entité"
      type="primaire"
    />
  {/snippet}
</HerosRiche>

<Notice
  description="Restez informé des dernières actualités de la directive NIS 2 et autres actualités."
  estRejetable
  titre="Newsletter MesServicesCyber :"
  lien={{
    libelle: 'S’abonner',
    titre: 'S’abonner à la newsletter',
    url: '/abonnement-infolettre?adresseRetour=/nis2',
  }}
/>

<NavigationTertiaire {liens} centré bind:lienActif />

<hr />

{#if estServeur || lienActif === '#presentation'}
  <Presentation />
{/if}
{#if estServeur || lienActif === '#exigences'}
  <ExigencesNis2 {featureFlagNis2CyFun23} {exigences} />
{/if}
{#if estServeur || lienActif === '#solutions'}
  <Solutions {itemsCyber} {guides} />
{/if}
{#if estServeur || lienActif === '#documentation'}
  <DocumentationNis2 />
{/if}

<style lang="scss">
  hr {
    border: 0;
    height: 24px;
    margin: 0;
  }

  img {
    width: 100%;
  }
</style>
